import GetResourceTextValueInteractor from "../../core/interactor/app/crud/GetResourceTextValueInteractor";
import Constants from "../common/Constants";

export default class GetNonAnonymisedCaseLawDocumentAttachmentsCountInteractor {
  private getResourceTextValue: GetResourceTextValueInteractor;

  constructor({ getResourceTextValue }: any) {
    this.getResourceTextValue = getResourceTextValue;
  }

  async execute(caseLawDocumentId: number) {
    let value = await this.getResourceTextValue.execute(
      `${Constants.endpointBasePath}/${caseLawDocumentId}/attachments/anonymised`
    );
    return Number.parseInt(value, 10);
  }
}
